
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'testString': 'test',
	'visualizationSlideoutTitle': 'Wizualizacje',
	'listSeparator': ',',
	'pointSeparator': ':',
	'minValuePlaceholder': 'Wprowadź liczbę',
	'maxValuePlaceholder': 'Wprowadź liczbę',
	'customRangeErrorMessage': 'Wartość musi być liczbą',
	'propFillColor': 'Kolor wypełnienia',
	'propBorderColor': 'Kolor krawędzi',
	'propColorPalette': 'Bieżąca paleta kolorów',
	'propColorPaletteChangeLabel': 'Zmień paletę kolorów',
	'propNewColorPaletteLabel': 'Utwórz niestandardową paletę kolorów',
	'propNewHeatPaletteLabel': 'Utwórz niestandardową paletę temperatury',
	'propDonutRadius': 'Promień pierścienia',
	'showTitleLabel': 'Pokaż tytuł',
	'titleTypeLabel': 'Typ tytułu',
	'smartTitleLabel': 'Tytuł inteligentny',
	'customTitleLabel': 'Tytuł niestandardowy',
	'noTitleLabel': 'Brak tytułu',
	'propHeatScalePalette': 'Bieżąca paleta natężeń',
	'propHeatPaletteChangeLabel': 'Zmień paletę natężeń',
	'propMaintainAxisScales': 'Zachowaj skalę osi',
	'propLineAndSymbolColor': 'Kolor linii i symbolu',
	'propLineAndSymbolPalette': 'Paleta kolorów linii i symboli',
	'propElementColor': 'Kolor elementu',
	'propColumnColor': 'Kolor kolumny',
	'propColumnPalette': 'Paleta kolorów kolumny',
	'propColumnHeatPalette': 'Paleta natężenia kolumn',
	'propBarColor': 'Kolor słupka',
	'propGoalColor': 'Kolor wartości przewidywanej',
	'propToColor': 'Kolor Do',
	'propFromColor': 'Kolor Od',
	'propNumberValidationErrorMessageId': 'Wprowadź liczbę',
	'fontSizeAuto': 'Auto',
	'propAutoBinCount': 'Liczba grup',
	'propAutoBinToggle': 'Grupowanie automatyczne',
	'tabName_general': 'Ogólne',
	'tabName_visDetails': 'Szczegóły',
	'tabName_animation': 'Animacja',
	'tabName_mediaDetails': 'Szczegóły multimediów',
	'tabName_webDetails': 'Szczegóły strony WWW',
	'tabName_imageDetails': 'Szczegóły obrazu',
	'tabName_visualization': 'Wizualizacja',
	'tabName_text': 'Tekst',
	'sectionName_colorsAndThemes': 'Kolor i kompozycje',
	'sectionName_appearance': 'Wygląd',
	'sectionName_general': 'Ogólne',
	'sectionName_colorPalette': 'Kolor',
	'sectionName_axis': 'Oś',
	'sectionName_axis_label': 'Oś',
	'sectionName_legend': 'Legenda',
	'sectionName_chart': 'Wykres',
	'sectionName_regionLayer': 'Warstwa regionów',
	'sectionName_pointLayer': 'Warstwa punktów',
	'sectionName_latLongLayer': 'Warstwa szerokości/długości geograficznej',
	'sectionName_pathLayer': 'Warstwa ścieżki',
	'sectionName_xAxis': 'Oś X',
	'sectionName_yAxis': 'Oś Y',
	'sectionName_xAxis_title': 'Tytuł osi X',
	'sectionName_yAxis_title': 'Tytuł osi Y',
	'sectionName_xAxis_label': 'Etykieta osi X',
	'sectionName_yAxis_label': 'Etykieta osi Y',
	'sectionName_column_yAxis': 'Oś Y (kolumna)',
	'sectionName_column_yAxis_label': 'Etykieta osi Y (kolumna)',
	'sectionName_column_yAxis_title': 'Tytuł osi Y (kolumna)',
	'sectionName_line_yAxis': 'Oś Y (wiersz)',
	'sectionName_line_yAxis_label': 'Etykieta osi Y (wiersz)',
	'sectionName_line_yAxis_title': 'Tytuł osi Y (wiersz)',
	'sectionName_title': 'Tytuł',
	'sectionName_dataValueLabels': 'Etykiety wartości danych',
	'sectionName_style': 'Styl',
	'propTransparencyDescription': 'Zwiększ lub zmniejsz przezroczystość obiektu. Wpisz wartość z przedziału od 0 do 100',
	'smart_annotation_unauthorized': 'Adnotacje: dostęp bez uprawnień',
	'smart_annotation_method': 'Adnotacje: metoda niedozwolona',
	'smart_annotation_media': 'Adnotacje: typ multimediów jest niedozwolony',
	'smart_annotation_input': 'Adnotacje: niepoprawne dane wejściowe',
	'smart_annotation_internal': 'Adnotacje: wewnętrzny błąd systemowy',
	'smart_annotation_generic_error': 'Adnotacje: błąd usługi',
	'smart_annotation_dialog_title': 'Spostrzeżenia',
	'smart_annotation_Show_Insights': 'Pokaż spostrzeżenia',
	'smart_annotation_Relationship': 'Relacja:',
	'forecast_enter_number': 'Wprowadź liczbę między ',
	'and': ' i ',
	'smart_errors': 'Błędy adnotacji:',
	'smart_warnings': 'Ostrzeżenia dotyczące adnotacji:',
	'smart_annotation_insight_icon_title': 'Spostrzeżenia',
	'smart_annotations_toggle_on': 'Włącz spostrzeżenia',
	'smart_annotations_toggle_off': 'Wyłącz spostrzeżenia',
	'smart_annotation_toggle_on': 'Włącz',
	'smart_annotation_toggle_off': 'Wyłącz',
	'smart_annotation_insight_unavailable': 'Są dostępne spostrzeżenia',
	'smart_annotation_insight_topBottom_percent_unsupported': 'Spostrzeżenia nie są dostępne, gdy aktywny jest filtr górnych lub dolnych %',
	'smart_annotation_forecast_topBottom_percent_unsupported': 'Prognoza nie jest dostępna, gdy aktywny jest filtr górnych lub dolnych %',
	'smart_annotation_insight_topBottom_nested_dataItem_unsupported': 'Spostrzeżenia nie są dostępne, gdy aktywny jest filtr górnych lub dolnych wartości, a pole zawiera więcej niż jedną kolumnę',
	'smart_annotation_forecast_topBottom_nested_dataItem_unsupported': 'Prognoza nie jest dostępna, gdy aktywny jest filtr górnych lub dolnych wartości, a pole zawiera więcej niż jedną kolumnę',
	'forecast_title': 'Prognoza',
	'forecast_show': 'Pokaż prognozę',
	'forecast_toggle_on': 'Przełącz prognozowanie na włączone',
	'forecast_toggle_off': 'Przełącz prognozowanie na wyłączone',
	'statDetailsPerspectiveTitle': 'Analiza',
	'emptyStatDetailsPanel': 'Dla bieżącej wizualizacji nie są dostępne dodatkowe analizy.',
	'predict_errors': 'Błędy analizy',
	'predict_warnings': 'Ostrzeżenia analizy',
	'fpd_invalid_data_source': 'To źródło danych nie ma powiązanego modułu inteligentnego',
	'fpd_network_issue': 'Wystąpił problem podczas wykonywania analizy dla tego źródła danych.',
	'fpd_data_source_category': 'Brak modułu inteligentnego',
	'fpd_response_errors': 'Błędy dotyczące zalecanego czynnika',
	'fpd_response_warnings': 'Ostrzeżenia dotyczące zalecanego czynnika',
	'catalyst_service_bad_request': 'Niepoprawne żądanie',
	'catalyst_service_unkown_Id': 'Napotkano nieznany id. żądania',
	'catalyst_service_internal_server_error': 'Wewnętrzny błąd serwera',
	'catalyst_service_generic_error': 'Błąd usługi Catalyst',
	'catalyst_service_error': 'Ta usługa nie jest obecnie dostępna',
	'propLegendPosition': 'Położenie legendy',
	'propLeft': 'Po lewej',
	'propRight': 'Po prawej',
	'propTop': 'U góry',
	'propBottom': 'U dołu',
	'propNone': 'Brak',
	'propLegendDisplay': 'Wyświetlaj legendę',
	'targetThicknessPlaceHolder': '%{min} do %{max}',
	'targetThicknessErrorMsg': 'Wprowadź liczbę całkowitą z zakresu od %{min} do %{max}.',
	'possibleKeyDriver_DialogDriversLabelBegin': 'Czynniki (',
	'possibleKeyDriver_DialogDriversLabelEnd': 'wybr.)',
	'possibleKeyDriver_DialogDriversLabelDivider': '/',
	'possibleKeyDriver_DialogDriversResetToDefaultsLabel': 'Przywróć ustawienia domyślne',
	'possibelKeyDriver_AddNewDrivers': 'Dodaj więcej czynników',
	'possibleKeyDrivers_NonRecommended_Placeholder': 'Wyszukaj, aby dodać więcej czynników',
	'possibleKeyDrivers_MaxPossibleReached': 'Anuluj wybór niektórych czynników, aby dodać lub wybrać inne',
	'possibleKeyDrivers_Recommended': 'Zalecany',
	'visRecommendedTypes': 'Polecane typy wizualizacji',
	'visRecommender_smartsfailure': 'rekomendacje wizualizacji nie są obecnie dostępne',
	'visMore': 'Więcej...',
	'visMoreTooltip': 'Więcej wizualizacji',
	'visOtherTypes': 'Inne typy wizualizacji',
	'visChange': 'Zmień wizualizację',
	'automaticTypeCaption': 'Automatycznie',
	'propVisType': 'Typy wizualizacji',
	'dlg_loading': 'Ładowanie...',
	'snippetListChartCaption': 'Lista wycinków',
	'convoClusterChartCaption': 'Grupa konwersacji',
	'areaChartCaption': 'Warstwowy',
	'barChartCaption': 'Słupkowy',
	'columnChartCaption': 'Kolumnowy',
	'stackedbarChartCaption': 'Skumulowany słupkowy',
	'stackedcolumnChartCaption': 'Skumulowany kolumnowy',
	'bubbleChartCaption': 'Bąbelkowy',
	'marimekkoChartCaption': 'Marimekko',
	'cometChartCaption': 'Analiza czynników',
	'scatterChartCaption': 'Wykres rozrzutu',
	'lineChartCaption': 'Liniowy',
	'pointChartCaption': 'Punktowy',
	'heatChartCaption': 'Mapa natężeń',
	'bulletChartCaption': 'Punktorowy',
	'waterfallChartCaption': 'Kaskadowy',
	'radarChartCaption': 'Radarowy',
	'boxplotChartCaption': 'Wykres skrzynkowy',
	'pieChartCaption': 'Kołowy',
	'mapChartCaption': 'Mapa',
	'radialBarChartCaption': 'Radialny',
	'compositeChartCaption': 'Linia i kolumna',
	'wordCloudChartCaption': 'Chmura słów',
	'networkChartCaption': 'Sieciowe',
	'relationshipNetworkChartCaption': 'Sieć relacji',
	'treemapChartCaption': 'Mapa drzewa',
	'packedBubbleChartCaption': 'Bąbelkowy upakowany',
	'hierarcicalPackedBubbleChartCaption': 'Dymek hierarchii',
	'spiralChartCaption': 'Spiralny',
	'decisionTreeChartCaption': 'Drzewo decyzyjne',
	'legacyMapChartCaption': 'Wcześniejsza mapa',
	'sunburstChartCaption': 'Słonecznikowy',
	'visUsageComparison': 'Porównanie',
	'visUsageRelationships': 'Relacje',
	'visUsageTrend': 'Trend',
	'visUsagePartsToWhole': 'Części całości',
	'visUsageGeospatial': 'Geoprzestrzennie',
	'visUsageAdvanced': 'Zaawansowana analiza',
	'visUsageTablesAndSummary': 'Tabele i podsumowanie',
	'visUsageSocialInsights': 'Spostrzeżenia społecznościowe',
	'visUsageOther': 'Inne',
	'autoBinActionText': 'Grupuj automatycznie',
	'filterAutobinActionText': 'Filtruj kategorie',
	'memberCalculationActionText': 'Obliczenie elementu',
	'toolbarActionCalculation': 'Utwórz obliczenie',
	'toolbarActionEditCalculation': 'Edytuj obliczenie',
	'topBottomRankLabel': 'Klasyfikacja (%{label})',
	'toolbarDeleteFilterActionText': 'Usuń filtr',
	'toolbarActionTopKeyDrivers': 'Pokaż czynniki',
	'toolbarActionCustomGroup': 'Grupa niestandardowa',
	'canNotCreateCustomGroup': 'Nie można utworzyć tej grupy niestandardowej.',
	'aria_label_datatable': 'Tabela danych',
	'summaryCaption': 'Podsumowanie',
	'MeasuresCaption': 'Miary',
	'MeasuresGroupCaption': 'Grupa miar (%{count})',
	'ValuesCaption': 'Wartości',
	'turnInsightsOn': 'Włącz spostrzeżenia',
	'turnInsightsOff': 'Wyłącz spostrzeżenia',
	'decisionRules': 'Reguły',
	'decisionTree': 'Diagram drzewa',
	'decisionSunburst': 'Pierścieniowy drzewa',
	'switchToDecisionRules': 'Przełącz na reguły decyzyjne',
	'switchToDecisionTree': 'Przełącz na drzewo decyzyjne',
	'data_group_less_then': 'mniejsze niż %{rangeTo}',
	'data_group_to': '%{rangeFrom} do < %{rangeTo}',
	'data_group_and_above': '%{rangeFrom} i powyżej',
	'nullValueContent': '(brak wartości)',
	'sum': 'Suma',
	'count': 'Liczebność',
	'countdistinct': 'Liczba wartości odrębnych',
	'avg': 'Średnia',
	'min': 'Minimum',
	'max': 'Maksimum',
	'automatic': 'Niestandardowe',
	'variance': 'Wariancja',
	'stddev': 'Odchylenie standardowe',
	'median': 'Mediana',
	'calculated': 'Obliczone',
	'none': 'Brak',
	'measureLabel': '%{measureName}',
	'multiMeasureLabel': '%{measureName} (%{aggregate})',
	'aggregatedColumnLabel': '%{column} (%{aggregationTypeLabel})',
	'promptTitle': 'Wartości pytania',
	'inputLabelPrompt': 'Wartość',
	'inputPlaceholderPrompt': 'Wprowadź wartość',
	'inputInvalidText': 'Niepoprawne dane wejściowe dla typu %{dataType}',
	'unSupportedPrompt': 'Nieobsługiwane pytanie',
	'missingDataSource': 'Nie można znaleźć właściwego źródła danych.',
	'unSupportedPromptType': 'Scenariusz pytania nie jest aktualnie obsługiwany.',
	'preAggregateLabel': 'Zastosuj wartości pytań ze źródła danych',
	'postAggregateLabel': 'Zastosuj wartości pytań w raporcie',
	'preAggregateText': 'W zakresie używane są wartości ze źródła danych, a nie wartości wyświetlane w kokpicie.',
	'defaultAggregation_count': 'Liczebność',
	'defaultAggregation_countdistinct': 'Liczba wartości odrębnych',
	'defaultAggregation_max': 'Maksimum',
	'defaultAggregation_min': 'Minimum',
	'defaultAggregation_avg': 'Średnia',
	'defaultAggregation_sum': 'Suma',
	'defaultAggregation_auto': 'Auto (%{aggregationType})',
	'keydriver_average': 'Średnia ogółem',
	'keydriver_up_down': 'Wyróżnione grupy z wysokimi lub niskimi średnimi mają większy wpływ na cel. Grupy z niezwykle wysokimi lub niskimi średnimi mają największy wpływ.',
	'keydriver_different': 'Wyróżnione grupy mają rozkłady istotnie różne od rozkładu ogólnego. Te grupy mają większy wpływ na cel.',
	'topOperator': 'U góry',
	'bottomOperator': 'U dołu',
	'topBottomFact': '%{operator} %{value}%{percent} na %{columnLabel}',
	'topBottomDimension': '%{operator} %{value}%{percent}',
	'deleteTopBottomCount': 'Usuń liczbę od góry lub od dołu',
	'deleteTopBottomPercent': 'Usuń % od góry lub od dołu',
	'topBottomTitle': 'Tylko ten obiekt',
	'deleteTopBottom': 'Usuń liczbę od góry lub od dołu',
	'editTopBottom': 'Edytuj liczbę od góry lub od dołu',
	'editTopBottomCount': 'Edytuj liczbę od góry lub od dołu',
	'editTopBottomPercent': 'Edytuj % od góry lub od dołu',
	'ariaDeleteTopBottomCountLabel': 'Naciśnij klawisz DELETE, aby usunąć liczbę od góry lub od dołu.',
	'ariaDeleteTopBottomPercentLabel': 'Naciśnij klawisz DELETE, aby usunąć % od góry lub od dołu.',
	'ariaEditTopBottomCountLabel': 'Naciśnij klawisz ENTER, aby edytować liczbę od góry lub od dołu.',
	'ariaEditTopBottomPercentLabel': 'Naciśnij klawisz ENTER, aby edytować % od góry lub od dołu.',
	'ariaDeleteDrillStateLabel': 'Naciśnij klawisz ENTER, aby edytować liczbę od góry lub od dołu.',
	'drillUpStateTitle': 'Drąż w górę',
	'drillDownStateTitle': 'Drąż w dół',
	'ariaEditTopBottomLabel': 'Naciśnij klawisz ENTER, aby edytować liczbę od góry lub od dołu.',
	'ariaDeleteTopBottomLabel': 'Naciśnij klawisz DELETE, aby usunąć liczbę od góry lub od dołu.',
	'allKeyDriversLabel': 'Auto (wszystkie czynniki)',
	'filter_drag_and_drop_single_dock': 'Przeciągnij i upuść dane w tym miejscu, aby przefiltrować.',
	'filter_drag_and_drop_all_tabs': 'Przeciągnij i upuść dane w tym miejscu, aby przefiltrować wszystkie karty.',
	'filter_drag_and_drop_current_tab': 'Przeciągnij i upuść dane w tym miejscu, aby przefiltrować tę kartę.',
	'filter_empty_consume_mode': 'Nie zastosowano żadnych filtrów.',
	'filterClearAllItems': 'Wyczyść wszystkie filtry',
	'filterDeleteAllItems': 'Usuń wszystkie filtry',
	'filterDockChevronLeft': 'Przewiń przez dane',
	'filterDockChevronRight': 'Przewiń przez dane',
	'filterIconLabel_Single': 'Filtry',
	'filterIconLabel_Global': 'Wszystkie karty',
	'filterIconLabel_Tab': 'Ta karta',
	'filterIconTooltip_Single': 'Filtry',
	'filterIconTooltip_Global': 'Filtry dla wszystkich kart',
	'filterIconTooltip_Tab': 'Filtry dla tej karty',
	'filterDropZoneTooltip_Single': 'Strefa upuszczania filtrów',
	'filterDropZoneTooltip_Global': 'Strefa upuszczania filtrów dla wszystkich kart',
	'filterDropZoneTooltip_Tab': 'Strefa upuszczania filtrów dla tej karty',
	'filterOverflowMenu': 'Więcej',
	'expand': 'Rozwiń',
	'collapse': 'Zwiń',
	'filterDockItemNameAriaLabel': 'Naciśnij klawisz Enter, aby otworzyć okno dialogowe filtrowania i zdefiniować filtr.',
	'filterItemCanvasMove': 'Dodaj do kanwy',
	'filterItemDelete': 'Usuń filtr',
	'filterInvertRange': 'wszystko z wyjątkiem: %{from}-%{to}',
	'filterRange': '%{from}-%{to}',
	'filter_date_after_except': 'Nie po %{from}',
	'filter_date_after': 'Po %{from}',
	'filter_date_before_except': 'Nie przed %{to}',
	'filter_date_before': 'Przed %{to}',
	'filter_date_between_except': 'Nie pomiędzy %{from}-%{to}',
	'filter_date_between': 'W zakresie %{from}-%{to}',
	'filterValueSeparator': ',',
	'filterAll': 'Wszystko',
	'filter': 'Filtruj',
	'filterExcept': 'z wyjątkiem %{values}',
	'filterDockToolbarButtonLabel': 'Dokowanie filtru',
	'navigateTitle': 'Nawiguj do',
	'navigateSelectColumn': 'Wybierz kolumnę',
	'navigateSelectPath': 'Wybierz ścieżkę nawigacji',
	'current_nav_group': 'Bieżąca grupa nawigacji: %{navigation_group_name}',
	'next': 'Dalej',
	'previous': 'Wstecz',
	'multiselectMsg': 'Wybrano %{count}',
	'errMsgFilterItemMissingTitle': 'Nie można załadować wartości filtru %{itemName}, ponieważ te wartości nie są dostępne z tym zestawem danych',
	'errMsgFilterItemGenericTitle': 'Nie można załadować wartości filtru',
	'textFilterItemsNotFound': 'Brak dostępnych elementów.',
	'nullValueLabel': '(wartość pusta)',
	'filterConditionLabel': 'Warunek filtrowania',
	'filter_includesAll': 'Uwzględnia wszystkie',
	'filter_allMembersOfSet': 'Wszystkie elementy zestawu',
	'modelFilter': 'Filtruj',
	'filtersTitle': 'Filtruj właściwości',
	'search': 'Szukaj',
	'clearTextFilterValue': 'Wyczyść',
	'invertFilterSelection': 'Odwróć',
	'modellingLoading': 'Ładowanie...',
	'searchAll': 'Znajdź wszystkie kolumny',
	'toolbarActionPossibleKeyDrivers': 'Edytuj zakres',
	'toolbarActionPossibleKeyDriversSubTitle': 'Przeciągnij elementy z lewej strony, aby wziąć je pod uwagę na wykresie analizy czynnika',
	'toolbarActionSort': 'Sortuj',
	'toolbarActionSortAscending': 'Rosnąco',
	'toolbarActionSortDescending': 'Malejąco',
	'toolbarActionSortAuto': 'Auto (%{sortOrder})',
	'toolbarActionSortCustom': 'Niestandardowe',
	'toolbarActionFormat': 'Formatuj dane',
	'toolbarActionFormatText': 'Formatowanie danych (tekst)',
	'toolbarActionFormatAbbreviation': 'Skracaj',
	'toolbarActionFormatNone': 'Auto',
	'toolbarActionFilter': 'Filtruj',
	'toolbarActionTopBottom': 'Od góry lub od dołu',
	'toolbarActionRmvShape': 'Usuń kształt',
	'toolbarActionToggleShapeDrop': 'Kształt infografiki',
	'toolbarActionToggleShapeDropTitle': 'Utwórz infografikę',
	'toolbarActionToggleShapeDropText': 'Przeciągnij kształt do tego pola, aby utworzyć infografikę.',
	'toolbarActionAggregationType': 'Podsumuj',
	'toolbarDeleteActionText': 'Usuń kolumnę',
	'toolbarTextActionText': 'Stylizacja tekstu',
	'toolbarActionFilterLocalKeepSelected': 'Zachowaj',
	'toolbarActionFilterLocalExcludeSelected': 'Wyklucz',
	'toolbarActionFilterAllKeepSelected': 'Filtruj',
	'toolbarActionSimpleCalculation': 'Proste obliczenie',
	'toolbarActionDrillBack': 'Wstecz',
	'toolbarActionDrillUp': 'Drąż w górę',
	'toolbarActionDrillDown': 'Drąż w dół',
	'toolbarActionJumpTo': 'Drążenie wszerz',
	'toolbarActionNavigate': 'Nawiguj',
	'toolbarActionCreateFilterGroup': 'Utwórz nowe połączenie',
	'toolbarActionDisconnectFilterGroup': 'Przerwij wszystkie odsyłacze',
	'toolbarActionLinkFilterGroup': 'Dodaj do istniejącego połączenia',
	'toolbarActionLassoSelect': 'Wybierz narzędzie',
	'toolbarActionRefreshDeveloperWidget': 'Odśwież',
	'textFontFamilySubClassHairline': 'Włosowa',
	'textFontFamilySubClassThin': 'Cienka',
	'textFontFamilySubClassThinItalic': 'Cienka kursywa',
	'textFontFamilySubClassExtraLight': 'Bardzo delikatna',
	'textFontFamilySubClassExtraLightItalic': 'Bardzo delikatna kursywa',
	'textFontFamilySubClassLight': 'Delikatna',
	'textFontFamilySubClassLightItalic': 'Delikatna kursywa',
	'textFontFamilySubClassRegular': 'Zwykła',
	'textFontFamilySubClassRegularItalic': 'Zwykła kursywa',
	'textFontFamilySubClassItalic': 'Kursywa',
	'textFontFamilySubClassMedium': 'Średnia',
	'textFontFamilySubClassMediumItalic': 'Średnia kursywa',
	'textFontFamilySubClassHeavy': 'Najgrubsza',
	'textFontFamilySubClassHeavyItalic': 'Najgrubsza kursywa',
	'textFontFamilySubClassDemiBold': 'Półpogrubiona',
	'textFontFamilySubClassDemiBoldItalic': 'Półpogrubiona kursywa',
	'textFontFamilySubClassBold': 'Pogrubiona',
	'textFontFamilySubClassBoldItalic': 'Pogrubiona kursywa',
	'textFontFamilySubClassExtraBold': 'Bardzo pogrubiona',
	'textFontFamilySubClassExtraBoldItalic': 'Bardzo pogrubiona kursywa',
	'textFontFamilySubClassBlack': 'Ciemna',
	'textFontFamilySubClassBlackItalic': 'Ciemna kursywa',
	'textFontFamilySubClassStencil': 'Wzornik',
	'dlg_ascending': 'rosnąco',
	'dlg_descending': 'malejąco',
	'dlg_custom': 'niestandardowe',
	'dlg_none': 'brak',
	'dlg_hierarchy': 'hierarchia',
	'dlg_namedSet': 'nazwany zestaw',
	'dlg_rank': 'rank',
	'visualizationLabel': 'Wizualizacja',
	'chartLabel': 'Wykres %{chartName}',
	'dataWidgetDescription': '%{widgetLabel}: %{columnNames}',
	'f12KeyDescription': 'Naciśnij F12, aby nawigować w widgecie',
	'f10KeyDescription': 'Naciśnij F10, aby uruchomić widok z aktywnym widgetem',
	'playButtonLabel': 'Odtwórz',
	'dataPlayerValueListLabel': 'Wartości odtwarzacza danych',
	'localFilterTitle': 'Tylko ten obiekt',
	'globalFilterTitle': 'Wszystkie obiekty',
	'deleteFilter': 'Usuń filtr',
	'editFilter': 'Edytuj filtr',
	'ariaEditFilterLabel': 'Aby edytować filtr, naciśnij klawisz ENTER.',
	'ariaDeleteFilterLabel': 'Aby usunąć filtr, naciśnij klawisz DELETE.',
	'measureFilterBetween': 'Między %{lowerBound} a %{upperBound}',
	'measureFilterNotBetween': 'Nie między %{lowerBound} a %{upperBound}',
	'dimFilterIn': 'Uwzględnia: %{in}',
	'dimFilterNotIn': 'Wyklucza: %{out}',
	'gtFilter': 'Po %{lowerBound}',
	'ltFilter': 'Przed %{upperBound}',
	'ariaEditPrompt': 'Naciśnij klawisz ENTER, aby zmienić wartość pytania',
	'dataPointFilterTitle': 'Punkty danych',
	'dataPointFilterIncludeSummary': 'Uwzględniono punktów danych: %{valueCount}',
	'dataPointFilterExcludeSummary': 'Wykluczono punktów danych: %{valueCount}',
	'widgetFiltersLabel': 'Filtry widgetu',
	'coachMarkTitleSpiralTarget': 'Edytuj zakres',
	'coachMarkContentSpiralTarget': 'W tym miejscu można uzyskać dostęp do czynników dla zmiennej przewidywanej i zmodyfikować ich wybór.',
	'srILVTreeLabel': 'Lista',
	'geomapUnrecognizedLocations': 'Nierozpoznane lokalizacje:',
	'geomapAmbiguousLocations': 'Regiony niejednoznaczne:',
	'visualizationNotifications': 'Powiadomienia o wizualizacji:',
	'dataNotifications': 'Powiadomienia o danych:',
	'autobinSuggestion': 'Włącz grupowanie automatyczne',
	'LIVE_empty_visualization_hint_title': 'Utwórz wizualizację',
	'LIVE_empty_visualization_hint_description': 'Przeciągnij dane tutaj lub na pola.',
	'LIVE_slots_required_field_description': '%{asterisk} oznacza pole wymagane',
	'LIVE_slots_drag_and_drop_description': 'Przeciągnij i upuść dane w powyższych polach, aby utworzyć i przefiltrować wizualizację.',
	'dwErrorLoadingAvailableVisualizations': 'Nie można załadować dostępnych definicji wizualizacji.',
	'moreDataIndicator': 'Twoje dane zostały obcięte przy takiej liczbie pozycji: %{threshold}. Zastosuj filtr, aby wyświetlać mniej.',
	'nonCtxTopBottomInvalid': 'Definiowanie reguły górnej lub dolnej bez kontekstu nie jest obsługiwane w przypadku tabel przestawianych. Została usunięta z tego widoku tabeli przestawnej.  Ponownie zdefiniuj regułę dla jednej lub większej liczby kategorii w kontekście %{columnName}.',
	'dwErrorLoadingVisualizationNotFound': 'Nie można załadować obiektu, ponieważ nie ma w nim definicji wizualizacji.',
	'dwErrorLoadingVisualizationListNotFound': 'Nie można załadować wizualizacji.',
	'dwErrorRunningQuery': 'Nie powiodło się pobranie danych z zestawu danych %{datasetName}.',
	'dwErrorGeoData': 'Wystąpił problem z wyświetleniem danych geograficznych na mapie. Wybierz inny typ wizualizacji.',
	'dwPromptSignonCancelWarning': 'Dane dla wizualizacji są niedostępne. Podaj poprawne dane uwierzytelniające.',
	'dwErrorMissingDataset': 'Nie można załadować wizualizacji, ponieważ nie jest dostępny skojarzony z nią zestaw danych "%{datasetName}".',
	'dwErrorRenderingVisualization': 'Nie można załadować tej wizualizacji.',
	'dwErrorVisualizationTooSmall': 'Wizualizacja jest zbyt mała, by pomieścić dane, które zawiera. Powiększ wizualizację lub ogranicz ilość zawartych w niej danych.',
	'errorSourceNotFound': 'Nie można załadować wizualizacji, ponieważ powiązane z nią źródło "%{sourceName}" jest niedostępne.',
	'errorActionNotSupported': 'Ta czynność nie jest obsługiwana w przypadku źródła danych "%{sourceName}".',
	'errorMeasureNotSupportedOnMultiEdges': 'Wizualizacja ma miary na więcej niż jednej krawędzi, co nie jest już obsługiwane. Umieść miary tylko na jednej krawędzi.',
	'errorExceedAllowableValue': 'Szacowana liczba komórek przekracza dozwoloną wartość 100000. Zastosuj filtrowanie do prognozowanych zbiorów, aby zmniejszyć liczbę komórek.',
	'propScaleLabel': 'Liczba ikon',
	'propScaleDescription': 'Wybierz liczbę ikon',
	'propScaleFew': 'Niska',
	'propScaleDefault': 'Domyślna',
	'propScaleMany': 'Wysoka',
	'lastRefresh': 'Ostatnie odświeżanie: upłynęło %{timeInterval}',
	'widgetTimer': 'Licznik czasu widgetu',
	'datasetItemsUnavailable': 'Niektóre elementy zestawu danych używane w tej wizualizacji są niedostępne.',
	'datasetItemUnavailable': 'Ten element zestawu danych jest niedostępny',
	'retry': 'Spróbuj ponownie',
	'widgetConditionalFormatLabel': 'Przełączaj elementy warunkowego sterowania formatami',
	'widgetConditionalFormatTitle': 'Edytuj kolor formatowania warunkowego',
	'crosstabName': 'Tabela przestawna',
	'WidgetLabelWithDescripion': '%{label}. %{description}',
	'value_is_not_available': 'Nie dotyczy',
	'summaryLabel': '%{label} z wartością %{value}',
	'infographicLabel': '%{label} z wartością %{value}',
	'warning': 'Ostrzeżenie',
	'swapRowsAndColumns': 'Zamień wiersze i kolumny',
	'hideSummariesLabel': 'Ukryj podsumowania',
	'showSummariesLabel': 'Pokaż podsumowania',
	'hideRowColumn': 'Ukryj',
	'showAllRowColumn': 'Pokaż wszystko',
	'dataAssetPropertiesLabel': 'Właściwości wizualizacji',
	'evAdd': 'Dodaj kolumnę',
	'evCollapse': 'Zwiń',
	'evColumns': 'Kolumny',
	'evLocalFilters': 'Filtry lokalne',
	'evExpand': 'Rozwiń',
	'evFilterTooltip': 'Filtruj',
	'missingColumn': 'Brak: %{columnLabel}',
	'missingFiltering': 'Brak filtrów dla kolumn:',
	'missingDataItem': 'Przywoływany element danych "%{dataItemId}" z referencją nie został znaleziony w widgecie.',
	'heatByLabel': 'Temperatura wg',
	'toolbarChangeVisualization': 'Zmień wizualizację',
	'modellingRelatedTablesNoneFound': 'Nie znaleziono pokrewnych tabel',
	'processing': 'Przetwarzanie...',
	'errorCellWarning': 'Nie można było obliczyć niektórych wartości podsumowania.',
	'aggregateTypeToggler': 'Pokaż typ agregacji',
	'maxColumnsExceeded': 'Przekroczono maksymalną liczbę kolumn. Usunięto %{columns}.',
	'unboundColumns': 'Nie można użyć następujących kolumn: %{columns}.',
	'unboundColumn': 'Nie można użyć następującej kolumny: %{columns}.',
	'recommendRequestFailed': 'Żądanie zalecenia nie powiodło się. Skontaktuj się z administratorem.',
	'visualizationDoesNotSupportOLAP': 'Nie można utworzyć tej wizualizacji opartej na źródle danych OLAP. Użyj innego obsługiwanego źródła danych.',
	'showDataBehindVizLabel': 'Pokaż dane',
	'showDataBehindVizNotSupportedLabel': 'Funkcja pokazywania danych nie jest obsługiwana dla tego typu wizualizacji',
	'exploreData': 'Eksploruj...',
	'newExplore': 'Nowa eksploracja',
	'thumbnails_error_fetching': 'Błąd podczas pobierania miniatur',
	'loadedThumbnailImage': 'Załadowano obraz miniatury wizualizacji %{visType}',
	'autobinAxisLabel': 'grupy',
	'recommended_visualizations': 'Zalecane wizualizacje',
	'all_visualizations': 'Wszystkie wizualizacje',
	'edit': 'Edytuj',
	'selectTargetDialogTitle': 'Wybierz cel drążenia wszerz',
	'noTargetInCM': 'Nie można znaleźć celu dla drążenia wszerz',
	'errorDrillDefinition': 'Wystąpił problem podczas dodawania lub edytowania definicji drążenia wszerz.',
	'errorDrillToTarget': 'Wystąpił błąd podczas drążenia do "%{targetName}"',
	'drillThroughMappingViewLabel': 'Przypisz kolumny z kokpitu do pytań w raporcie docelowym',
	'drillthroughScopeRadioLabel': 'Zastosuj tę definicję do:',
	'drillthroughScopeRadioOptionVisualization': 'Tylko tej wizualizacji',
	'drillthroughScopeRadioOptionConnection': 'Wizualizacji w tym samym połączeniu, które korzystają z tego samego źródła danych',
	'drillthroughScopeRadioOptionDashboard': 'Dowolnej wizualizacji w %{perspective}, która korzysta z tego samego źródła danych',
	'drillThroughParametersColumnTitle': 'Pytania "%{targetName}":',
	'drillThroughMetadataColumnTitle': 'Kolumny danych "%{boardName}":',
	'drillThroughDefinitionNoParameter': 'Cel drążenia wszerz nie ma pytań.',
	'drillThroughDefinitionErrorQueryingReport': 'Rozwiąż problem związany z raportem docelowym, a następnie spróbuj ponownie utworzyć definicję drążenia wszerz.',
	'drillThroughDefinitionErrorDlgTitle': 'Coś poszło nie tak',
	'dlg_back': 'Wstecz',
	'dlg_close': 'Zamknij',
	'dlg_ok': 'OK',
	'dlg_cancel': 'Anuluj',
	'dlg_apply': 'Zastosuj',
	'dlg_create': 'Utwórz',
	'dlg_done': 'Gotowe',
	'drillthrough_unsaveMsg': 'Kontynuować bez zapisania "%{name}"?',
	'drillthrough_jumpTo': 'Definicja drążenia wszerz: %{name}',
	'drillthrough_jumpToLabel': 'Drążenie wszerz',
	'drillthrough_manage': 'Zarządzaj...',
	'drillthrough_addNewTarget': 'Dodaj nową definicję drążenia wszerz',
	'drillthrough_manageJumpPaths': 'Zarządzaj definicjami drążenia wszerz',
	'drillthrough_manageJumpPaths_edit': 'Edytuj "%{name}"',
	'drillthrough_manageJumpPaths_delete': 'Usuń "%{name}"',
	'drillthrough_manageAddAnotherTarget': 'Dodaj następną definicję drążenia wszerz',
	'drillthrough_manageConfirmeDeleteDrillTargetTitle': 'Potwierdź usunięcie',
	'drillthrough_manageConfirmeDeleteDrillTarget': 'Czy na pewno chcesz usunąć drążenie wszerz "%{name}"?',
	'drillthrough_definitionDuplicateDrillTargetErrorTitle': 'Zduplikowana nazwa drążenia wszerz',
	'drillthrough_definitionMessage': 'Drążenie wszerz "%{name}" już istnieje. Podaj inną nazwę',
	'drillthrough_jumpToTarget_notFound': 'Nie znaleziono celu drążenia wszerz "%{name}"',
	'drillThroughDefinitionNoParameterSubTitle': 'Żaden kontekst nie zostanie przekazany do raportu docelowego.',
	'drillthrough_titleLabel': 'Nazwa',
	'drillthrough_create_dialogTitle': 'Utwórz definicję drążenia wszerz',
	'drillthrough_edit_dialogTitle': 'Edytuj definicję drążenia wszerz',
	'drillthrough_subTitle': 'Kontekst wizualizacji w źródle jest używany do filtrowania celu %{perspective}.',
	'drillthrough_selectColumn': 'Wybierz kolumnę',
	'noPrompt': 'Brak pytań',
	'promptDialog': 'Okno dialogowe pytania %{promptType}',
	'formatAutoDescription': 'Opcja Automatycznie określa format dziedziczony ze źródła danych lub wizualizacji.',
	'formatDefaultDescription': 'Domyślne określa format dziedziczony z systemu',
	'createCustomGroupAction': 'Utwórz grupę danych',
	'removeCustomGroupAction': 'Usuń grupę danych',
	'editCustomGroupAction': 'Edytuj grupę danych',
	'renameCustomGroupAction': 'Zmień nazwę grupy danych',
	'createCustomGroupErrorToast': 'Nie powiodło się utworzenie grupy danych.',
	'removeCustomGroupErrorToast': 'Nie powiodło się usunięcie grupy danych.',
	'editCustomGroupErrorToast': 'Nie powiodło się edytowanie grupy danych.',
	'renameCustomGroupErrorToast': 'Nie powiodła się zmiana nazwy grupy danych.',
	'customGroupLabel': 'Utwórz grupę danych',
	'ungroupCustomGroupLabel': 'Rozgrupuj',
	'renameCustomGroupLabel': 'Zmień nazwę',
	'createCustomGroupLabel': 'Utwórz',
	'customGroupingLabel': '%{columnLabel} (grupa)',
	'createCustomSort': 'Utwórz sortowanie niestandardowe',
	'createCustomSortTitle': '%{name}',
	'createCustomSortDesc': 'Wybierz dostępne elementy, a następnie zmień ich kolejność, aby utworzyć niestandardowe sortowanie.',
	'availableItems': 'Dostępne elementy',
	'selectAll': 'Wybierz wszystkie',
	'customSortOrder': 'Niestandardowy porządek sortowania',
	'selectAvailableItemsDesc': 'Wybierz dostępne elementy, a następnie tutaj zmień ich kolejność.',
	'moveToTop': 'Przenieś na początek',
	'clear': 'Wyczyść',
	'sortRemainingItemsBy': 'Posortuj pozostałe elementy wg',
	'removeAll': 'Usuń wszystkie',
	'resetTooltip': 'Wszystkie elementy zostaną usunięte z listy %{customSortOrder}. Ponadto lista rozwijana %{sortRemainingItemsBy} zostanie przywrócona do jej stanu domyślnego.',
	'manyItemsWarning': 'Wybranie wielu elementów może niekorzystnie wpłynąć na wydajność kokpitu.',
	'manyItemsSelected': 'Liczba wybranych elementów przekracza %{maxItems}. Może to niekorzystnie wpłynąć na wydajność kokpitu.',
	'somethingWentWrong': 'Niestety, wystąpił problem.',
	'tryAgain': 'Spróbuj ponownie',
	'customSortLabel': 'Niestandardowe sortowanie',
	'applyError': 'Nie można zastosować %{action}.',
	'searchReturnedNoResults': 'Wyszukiwanie nie zwróciło żadnych wyników.',
	'extVisSystem': 'System',
	'extVisCustom': 'Niestandardowe',
	'customVisTestVisualization': 'Wizualizacja testu',
	'extVisCustomVisPreview': 'podgląd',
	'extVisCustomPreviewWidgets': 'Widgety programistów',
	'extVisCustomVVisualization': 'Wizualizacja',
	'extVisCustomVisuals': 'Niestandardowe elementy wizualne',
	'noPermissionToManage': 'Użytkownik nie ma uprawnień do zarządzania wizualizacjami niestandardowymi.',
	'extVisCustomUpdate': 'Aktualizuj',
	'extVisCustomDelete': 'Usuń',
	'extVisNoCustomVisuals': 'Brak niestandardowych elementów wizualnych',
	'extVisNoCustomVisualsMsg': 'Obecnie w organizacji nie ma żadnych niestandardowych elementów wizualnych',
	'extVisAddCustomVisual': 'Dodaj niestandardowy element wizualny',
	'extVisNoCustomVisualsAdminMsg': 'Obecnie nie ma żadnych niestandardowych elementów wizualnych. Aby rozpocząć, dodaj taki element',
	'extVisNoSDKConnection': 'Nie utworzono połączenia z plikiem lokalnym',
	'extVisNoSDKPreviewMsg': 'Aby wyświetlić podgląd wizualizacji, należy nawiązać połączenie.',
	'extVisMore': 'Więcej',
	'extVisDeleteDialogTitle': 'Usuń niestandardowy element wizualny',
	'extVisDeleteDialogBody': 'Czy na pewno chcesz usunąć tę wizualizację niestandardową? Być może jest używana w innych kokpitach i raportach.',
	'extVisDeleteConfirmation': 'Niestandardowy element wizualny został usunięty.',
	'extVisDeleteError': 'Nie powiodło się usunięcie niestandardowego elementu wizualnego. %{msg}',
	'extVisCloseToast': 'Zamknij teraz',
	'extVisAdd': 'Niestandardowy element wizualny został pomyślnie dodany.',
	'extVisAddError': 'Nie powiodło się dodanie niestandardowego elementu wizualnego. %{msg}',
	'extVisUpdate': 'Niestandardowy element wizualny został pomyślnie zaktualizowany.',
	'extVisUpdateError': 'Nie powiodło się zaktualizowanie niestandardowego elementu wizualnego. %{msg}',
	'extVisAddProgress': 'Importowanie %{name}',
	'extVisUpdateProgress': 'Aktualizowanie %{name}',
	'extPermissionTitle': 'Ograniczony dostęp lub usunięty niestandardowy element wizualny',
	'extPermissionBody': 'Nie można wyświetlić tego niestandardowego elementu wizualnego, ponieważ został on usunięty lub dostęp do niego jest ograniczony.',
	'customVizSaveWarning': 'Nie można zapisać niestandardowych elementów wizualnych. Nie zostały zaimportowane.',
	'schematicTestCaption': 'Schemat testu',
	'schematicServiceRequestError': 'Błąd usługi schematu',
	'extVisPreviewMessage': 'To jest podgląd. Wizualizacja nie została jeszcze dodana do produktu.',
	'kpiTargetWithDistance': '%{value} (%{distance})',
	'kpiDistanceUndefined': 'Niezdefiniowane',
	'kpiDefaultTargetLabel': 'Cel',
	'kpiNonNumericTarget': 'Wartość docelowa musi być liczbą.',
	'kpiManualTargetSlotFilled': 'Wartość zastosowana w polu',
	'kpiAutoValueSize': 'Auto',
	'kpiUnableDrawSparklineLabel': 'Nie można narysować miniwykresu Sparkline',
	'kpiUnableDrawSparklineInfo': 'Miniwykres Sparkline wymaga co najmniej dwóch punktów w czasie. Zmień dane lub dostosuj filtry w celu wyświetlenia miniwykresu Sparkline.',
	'conditionalFormattingTextColor': 'Kolor tekstu',
	'suppression': 'Pomijanie',
	'suppressNone': 'Brak',
	'suppressRowsAndColumns': 'Wiersze i kolumny',
	'suppressRows': 'Wiersze',
	'suppressColumns': 'Kolumny',
	'enableSuppression': 'Włącz pomijanie',
	'disableSuppression': 'Wyłącz pomijanie',
	'loadVisDefinitionError': 'Nie można załadować definicji wizualizacji %{id}',
	'emptyVisualization': 'Pusta wizualizacja',
	'expandCollapse': 'Rozwiń i zwiń',
	'expandBtnLabel': 'Rozwiń',
	'collapseBtnLabel': 'Zwiń',
	'prop_sizeInputNonNumericValue': 'Wartość musi być liczbą.',
	'prop_sizeValueShouldBeHigher': 'Wartość musi być większa od %{value}.',
	'fontPropLabel': 'Rodzina czcionek',
	'fontSizePropLabel': 'Rozmiar czcionki',
	'sectionItemAxisTitle': 'Tytuł osi elementów',
	'sectionItemAxisLabel': 'Etykieta osi elementów',
	'sectionValueAxisTitle': 'Tytuł osi wartości',
	'sectionValueAxisLabel': 'Etykieta osi wartości',
	'styletext-widget.legend': 'Legenda',
	'styletext-itemAxis.ticks.labels': 'Etykiety osi',
	'styletext-valueAxis.title': 'Tytuły osi',
	'styletext-itemAxis.title': 'Tytuły osi',
	'styletext-labels': 'Etykiety danych',
	'styletext-valueAxis.line.title': 'Tytuły wierszy',
	'styletext-cellValue': 'Wartości',
	'styletext-values': 'Wartości',
	'styletext-rowHeading': 'Nagłówki wierszy',
	'styletext-columnHeading': 'Nagłówki kolumn',
	'fontFamily': 'rodzina',
	'fontSize': 'rozmiar',
	'visExportFileName': 'Wizualizacja',
	'ds-missingDataSet': 'Nie można znaleźć zestawu danych. Upewnij się, że zestaw danych został utworzony pomyślnie.',
	'ds-missingDashboardId': 'Zapisz kokpit przed utworzeniem zestawu danych.',
	'ds-unsupportedDataSourceType': 'Typ źródła danych %{type} nie jest obsługiwany.',
	'dataCache': 'Pamięć podręczna danych',
	'dataCache_on': 'Wł.',
	'dataCache_off': 'Bez pamięci podręcznej',
	'dataCache_auto': 'Automatycznie',
	'queryOptimization': 'Optymalizacja zapytań'
});
